import './ErrorBoundary.scss';
import FaIcon from '../FaIcon';
import { Button } from 'rsuite';
import { Component } from 'react';

export default class ErrorBoundary extends Component {
	state = { hasError: false, remainTime: 10 };

	static getDerivedStateFromError(error: any) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error: any, errorInfo: any) {
		console.error(error, errorInfo);
		if (window.MODE === 'LOCAL') return;

		// Catch Chunk/asset loading errors caused by outdated cached index.html
		const errorText = (error?.message || error?.name || '').toString();
		const isChunkError = /ChunkLoadError|Loading chunk|Loading CSS chunk/i.test(errorText);

		if (isChunkError) {
			const urlParams = new URLSearchParams(window.location.search);
			const reloadTime = urlParams.get('reload');
			const now = Date.now();

			// Reload with a timestamp parameter to force CDN & browser cache bypass
			if (!reloadTime || now - parseInt(reloadTime, 10) > 10000) {
				urlParams.set('reload', now.toString());
				window.location.href = window.location.pathname + '?' + urlParams.toString() + window.location.hash;
				return;
			}
		}

		const interval = setInterval(() => {
			this.setState((s: any) => {
				if (s.remainTime === 0) {
					window.location.href = '/';
					return clearInterval(interval);
				}
				return { ...s, remainTime: s.remainTime - 1 };
			});
		}, 1000);
	}

	render() {
		if (!this.state.hasError) return this.props.children;
		return (
			<div className='error-boundary-layout'>
				<FaIcon fa='s-exclamation' className='w-1/3' />
				<h1>Something went wrong !</h1>
				<Button href='/' className='go-to-home-btn'>
					Back to home
					{this.state.remainTime !== 0 ? ` (${this.state.remainTime}s)` : ''}
				</Button>
				<Button className='report-btn' href='mailto:amir@auto-hq.com'>
					Report to AutoHQ
				</Button>
			</div>
		);
	}
}
